import { render, staticRenderFns } from "./ModalMarcador.vue?vue&type=template&id=6209d530&"
import script from "./ModalMarcador.vue?vue&type=script&lang=js&"
export * from "./ModalMarcador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports